import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastService } from 'angular-toastify';
import { ImageFiles, IUploadImage } from 'src/app/shared/models/image-upload.model';
import { DIFFICULTY, IQuestionsRow } from 'src/app/shared/models/lesson-content.model';
import { ImageUploaderService } from 'src/app/shared/services/image-uploader.service';

@Component({
  selector: 'app-add-question',
  templateUrl: './add-question.component.html',
  styleUrls: ['./add-question.component.scss']
})
export class AddQuestionDialog implements OnInit {

	readonly difficulties = DIFFICULTY;

	public files: ImageFiles[] = [];

	imageExists: boolean = false;
	toVerify: boolean = false;
	imageVerify!: string;
	keys: string = '';

	questionControl = new FormControl(this.data.question, Validators.required);
	keysControl = new FormControl(this.keys, Validators.required);
	minWordsControl = new FormControl(this.data.minWords, Validators.required);

	constructor(
		public dialogRef: MatDialogRef<AddQuestionDialog>,
		@Inject(MAT_DIALOG_DATA) public data: IQuestionsRow,
		private toastService: ToastService,
		private uploadService: ImageUploaderService,
	) {}

	ngOnInit(): void {

	}

	closeDialog() {
		this.dialogRef.close()
	}

	changeImage(newValue: string) {
		this.data.imageId = newValue;
		this.toVerify = false;
		this.files = [];
		this.imageExists = false;
	}

	verifyImage() {
		this.imageVerify = this.data.imageId;
		this.toVerify = true;
	}

	setFile(file: ImageFiles | null) {
		if (file === null) {
			this.data.imageId = '';
			this.files = [];
			return;
		}
		this.data.imageId = file.name;
		this.files.push(file);
	}

	createQuestion() {
		let canUpload = true;

		this.data.question = this.questionControl.value;
		this.keys = this.keysControl.value;
		this.data.minWords = this.minWordsControl.value;

		if (this.data.question === '') {
			this.questionControl.markAsTouched();
			canUpload = false;
		}

		if (this.keys === '') {
			this.keysControl.markAsTouched();
			canUpload = false;
		}

		if (this.data.minWords === 0) {
			this.minWordsControl.markAsTouched();
			canUpload = false;
		}

		if (!this.imageExists && this.files.length === 0) {
			this.toastService.error('No image has been selected.')
			return;
		}

		if (!canUpload) {
			this.toastService.error('Failed to save new question.')
			return;
		}

		// what will be removed from vector
		let remove = /\s*,\s*/;

		// Create vector of keywords with separator ',' and ignore spaces between the separator
		this.data.keywords = this.keys.split(remove);

		if (this.files.length > 0) {
			const uploadFileIds = this.files.map(file => {
				return {
					id: file.name,
					extension: 'jpg',
				} as IUploadImage;
			})

			const fileBlobs = this.files.map(fileInfo => {
				const imageBlob = new Blob([fileInfo.file], {type: `image/jpeg`})
				return imageBlob;
			});

			this.uploadService.uploadImages(fileBlobs, uploadFileIds).subscribe(res => {
				if (!res) {
					this.toastService.error('Failed to upload image');
					return;
				} else {
					this.toastService.success('Image was uploaded successfully');
					this.toastService.success('Question added.')
					this.dialogRef.close(this.data);
				}
			});
		} else {
			this.toastService.success('Question added.')
			this.dialogRef.close(this.data);
		}
	}
}
